module.exports = __webpack_public_path__ + "assets/img/flecha-izquierda-1.1bbcfd5c.svg";